import React from "react";
import "./SongCube.scss";
import { useContext } from "react";
import { AppContext } from "../../stores/application.store";
import { useState, useRef, useEffect } from "react";
import { isMobile, isIos } from "../../services/agent";
import Loader from "../Animations/Loader/Loader";
import data from "../../static/data/data.json";
import { ga_push } from "../../services/analytics";
const SongCube = (props) => {
  const {
    bestSongs,
    toggleSongVote,
    setSongPlaying,
    setSongElement,
    songPlaying,
    songsCubeShowing,
    setAudioDuration,
    currentAudioTime,
    currentAudioDuration,
  } = useContext(AppContext);

  const songElement = useRef(null);

  const PlaySongPress = (id, event) => {
    let song = data.Songs.find((x) => x.ID == id);
    if (song) {
      ga_push(
        "audio_events",
        "Audio",
        "Play",
        `${song.ArtistName} - ${song.SongName}`
      );
    }
    songElement.current.src = props.song.Link;
    setSongElement(songElement.current);
    setSongPlaying(id);
    event.stopPropagation();
  };

  useEffect(() => {
    if (songPlaying != props.song.ID)
      songElement.current.pause();
      
  }, [songPlaying]);

  const CheckSongPress = (id, event) => {
    toggleSongVote(id);
    event.stopPropagation();
  };
  const cubeRef = useRef();

  return (
    <div className={`song-cube `} ref={cubeRef}>

      <div
        id={`image-${props.song.ID}`}
        className={`song-image 
        ${songPlaying == props.song.ID ? "playing" : ""}
        ${bestSongs.includes(props.song.ID) ? "checked " : " "}
        ${songsCubeShowing.includes(props.song.ID) ? "showing" : ""}
        ${`image-${props.song.ID}`}
        `}

        onClick={() => toggleSongVote(props.song.ID)}
      >
        {!bestSongs.includes(props.song.ID) && !bestSongs.includes(0) && (
          <div className="fade"></div>
        )}
        <div
          className={`check-button`}
          onClick={(e) => CheckSongPress(props.song.ID, e)}
        >
          <div className="desktop-only">בחירה</div>
        </div>
        <div
          className={`play-button`}
          onClick={(e) => {
            props.song.ID == songPlaying
              ? PlaySongPress(0, e)
              : PlaySongPress(props.song.ID, e)
          }}
        >
          <Loader songId={props.song.ID} />
          <video style={{ display: "none" }}
            playsInline={"playsInline"}
            loop={false}
            preload={"auto"}
            controls={false}
            ref={songElement}
            // src={props.song.Link}
          ></video>
        </div>

        {/* <div className="loader-container">
          <Loader songId={props.song.ID}/>
        </div> */}
      </div>

      <h4 className="song-title">{props.song.SongName}</h4>
      <h4 className="song-artist">{props.song.ArtistName}</h4>
    </div>
  );
};

export default SongCube;
